import * as React from "react";
import { CardTitle } from "reactstrap";
import { CardBody } from "reactstrap";
import { Row, Col, Card } from "reactstrap";
// import "./style.scss";

import { Button } from "reactstrap";
// import avatar from "../../images/Danalarge.svg";
import { useContext } from "react";
// import { UserContext } from "../../bankUserContext";
import avatar from "../../../../images/Danalarge.svg";

export function Assist(props: any) {
  // const user = useContext(UserContext);
  return (
    <Row>
      <Col md="12">
        <div className="imgAvatar">
          <img src={avatar} alt="avatar" />
        </div>
        <Card className="card">
          <div className="arrow-left"></div>
          <CardTitle>Hi,</CardTitle>
          <CardBody>
            <p>
            I’m DANA, your virtual assistant, and I{"'"}m here to guide you through the application process.
            </p>

            {/* <p>
            To focus and make this process easier for you, we have organized this application into categories. 
            The information you provide here will help us ensure that your business and our 
            bank are compliant with current regulations.
            </p> */}
            <p>
            We will auto-save your work as you complete each item, 
            so you do not need to complete the full application in one session. 
            </p>
            <p>
            Let’s get started!
            </p>
          </CardBody>
        </Card>
        <Button className="NextBtn" onClick={props.setNext}> Next </Button>
      </Col>
    </Row>
  );
}
